import React from 'react';
import {
  ChakraProvider as ChakraProvider,
  useTheme as chakraUseTheme,
} from '@chakra-ui/react';
import createTheme from '@mui/material/styles/createTheme';
import MuiThemeProvider from '@mui/material/styles/ThemeProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

const ThemeProvider = ({ children, theme }: any) => {
  const muiTheme = createTheme(theme);
  return (
    <ChakraProvider theme={theme} resetCSS>
      <MuiThemeProvider theme={muiTheme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          {children}
        </LocalizationProvider>
      </MuiThemeProvider>
    </ChakraProvider>
  );
};

const useTheme = chakraUseTheme;

export { ThemeProvider, useTheme };
